module.exports = __webpack_public_path__ + "static/media/external-link.1bf13c02.png";